var casestudy_frame = require('./casestudy_frame');
var checkProgress = require('./casestudy_checkprogress');
var caseStudySlide = require('./casestudy_slide');

var CaseStudy = function(casestudy,modal,dashboardLink) {
    var _global = { casestudy:casestudy,modal:modal,currentSlide: 0,dashboardLink:dashboardLink};

    var frame = casestudy_frame();
    $(casestudy).append(frame);
    var question = questions[_global.currentSlide];

    caseStudySlide(question,frame,modal);

    checkProgress(_global);
    // buttons



    $('#show-answer').click( function() {
        // toggle flipped
        var question = questions[_global.currentSlide];
        var modalDiv = $('#'+ global.modal);
        $(modalDiv).on('hidden.bs.modal', function (e) {
            $(modalDiv).find('.modal-content').html('');
        });
        var modalcontentstr = '<div class="modal-body">';

        if (question.user_choice == question.acf.correct_choice) {
            modalcontentstr += '<h2>Correct!</h2>';
        } else {
            var correct_answer = question.acf['choice_' + question.acf.correct_choice];
            var your_answer = question.acf['choice_' + question.user_choice];
            modalcontentstr += '<h2>Incorrect!</h2>Your choice: '+ your_answer +'<br />Correct choice: ' + correct_answer + '<br />';
        }
        modalcontentstr += question.acf.case_review;

        modalcontentstr +='</div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div>';
        var modalContent = $.parseHTML(modalcontentstr);
        $(modalDiv).find('.modal-content').append(modalContent);
        $(modalDiv).modal();
    });

    $(frame).find('button.previous').click(function() {
        if (_global.currentSlide > 0 ) {
            _global.currentSlide--;
            var question = questions[_global.currentSlide];

            caseStudySlide(question,frame,modal);

            checkProgress(_global);
        }
    });

    $(frame).find('button.next').click(function() {
        if (_global.currentSlide < questions.length ) {
            _global.currentSlide++ ;
            var question = questions[_global.currentSlide];

            caseStudySlide(question,frame,modal);

            checkProgress(_global);
        }
    });
    $('#finish').click(function() {
        // take over the node
        document.location.href = dashboardLink;
    });

};

module.exports = CaseStudy;


//////////////////
// WEBPACK FOOTER
// ./src/case_study.js
// module id = 292
// module chunks = 0